import type { IconProps } from './types/types';

const OkendoIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3C10.4289 3 8.95333 3.40444 7.66887 4.11111C7.66887 4.11111 11.9911 4.11111 12 4.11111C16.3489 4.11111 19.8889 7.64889 19.8889 12C19.8889 16.3511 16.3511 19.8889 12 19.8889C7.64889 19.8889 4.11111 16.3511 4.11111 12C4.11111 11.2222 4.22667 10.4689 4.43778 9.76H3.28222C3.09778 10.4756 3 11.2267 3 12C3 16.9689 7.02889 21 12 21C16.9711 21 21 16.9711 21 12C21 7.02889 16.9711 3 12 3Z"
      fill="black"
    />
    <path
      d="M6.03111 5.26953C5.64888 5.60953 5.29333 5.98064 4.97333 6.38064H12C15.0978 6.38064 17.6178 8.90064 17.6178 11.9984C17.6178 15.0962 15.0978 17.6162 12 17.6162C8.90222 17.6162 6.38222 15.0962 6.38222 11.9984C6.38222 11.2029 6.54888 10.4451 6.84888 9.75842H5.65555C5.40666 10.4584 5.27111 11.214 5.27111 11.9984C5.27111 15.7162 8.28444 18.7273 12 18.7273C15.7155 18.7273 18.7289 15.714 18.7289 11.9984C18.7289 8.28286 15.7155 5.26953 12 5.26953H6.03111Z"
      fill="black"
    />
    <path
      d="M12 8.62478C13.86 8.62478 15.3733 10.1381 15.3733 11.9981C15.3733 13.8581 13.86 15.3714 12 15.3714C10.14 15.3714 8.62664 13.8581 8.62664 11.9981C8.62664 11.1381 8.95331 10.3537 9.48442 9.75812H8.11775C7.73553 10.4181 7.51331 11.1826 7.51331 11.9981C7.51331 14.4759 9.5222 16.4826 11.9978 16.4826C14.4733 16.4826 16.4822 14.4737 16.4822 11.9981C16.4822 9.52256 14.4733 7.51367 11.9978 7.51367H4.2022C3.99775 7.86923 3.81553 8.24034 3.65997 8.62478H12Z"
      fill="black"
    />
  </svg>
);

export default OkendoIcon;
